export const GET_ACTIVE_FINAL_EXAMS_BEGIN = "GET_ACTIVE_FINAL_EXAMS_BEGIN";
export const GET_ACTIVE_FINAL_EXAMS_FULFILLED =
  "GET_ACTIVE_FINAL_EXAMS_FULFILLED";
export const GET_ACTIVE_FINAL_EXAMS_REJECTED =
  "GET_ACTIVE_FINAL_EXAMS_REJECTED";

export const GET_NBROF_ACTIVATED_FINAL_EXAMS_BEGIN =
  "GET_NBROF_ACTIVATED_FINAL_EXAMS_BEGIN";
export const GET_NBROF_ACTIVATED_FINAL_EXAMS_FULFILLED =
  "GET_NBROF_ACTIVATED_FINAL_EXAMS_FULFILLED";
export const GET_NBROF_ACTIVATED_FINAL_EXAMS_REJECTED =
  "GET_NBROF_ACTIVATED_FINAL_EXAMS_REJECTED";

const initialFinalExamState = {
  loading: false,
  result: [],
  error: null
};

export function finalExamReducer(state = initialFinalExamState, action = {}) {
  switch (action.type) {
    case GET_ACTIVE_FINAL_EXAMS_BEGIN: {
      return { ...state, loading: true, error: null };
    }
    case GET_ACTIVE_FINAL_EXAMS_FULFILLED: {
      return { ...state, loading: false, error: null, result: action.payload };
    }
    case GET_ACTIVE_FINAL_EXAMS_REJECTED: {
      return { ...state, loading: false, error: action.payload.error };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_NBR_OF_ACTIVATED = {
  loading: false,
  result: [],
  error: null
};

export function nbrOfActivatedFinalExamsReducer(
  state = INIT_NBR_OF_ACTIVATED,
  action = {}
) {
  switch (action.type) {
    case GET_NBROF_ACTIVATED_FINAL_EXAMS_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_NBROF_ACTIVATED_FINAL_EXAMS_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case GET_ACTIVE_FINAL_EXAMS_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}
